// The text field style shared by the Flutter auth screens: black @70% fill,
// 20px rounded outline in #01111F, FontColor text/hint, and a leading icon.

import React from 'react';
import { TextField, InputAdornment, useTheme } from '@mui/material';

export default function AuthField({
  icon, endAdornment, maxLength, sx, ...props
}) {
  const theme = useTheme();
  const c = theme.sli;
  return (
    <TextField
      fullWidth
      variant="outlined"
      inputProps={maxLength ? { maxLength } : undefined}
      InputProps={{
        startAdornment: icon
          ? <InputAdornment position="start" sx={{ color: c.text }}>{icon}</InputAdornment>
          : undefined,
        endAdornment,
        sx: {
          bgcolor: 'rgba(0,0,0,0.7)',
          borderRadius: '20px',
          color: c.text,
          fontSize: 15,
          '& fieldset': { borderColor: '#01111F', borderWidth: 2 },
          '&:hover fieldset': { borderColor: '#01111F' },
          '&.Mui-focused fieldset': { borderColor: '#01111F' },
          '& input::placeholder': { color: c.text, opacity: 1 },
        },
      }}
      sx={sx}
      {...props}
    />
  );
}
